import { defineStore } from 'pinia'

export const useUtilsStore = defineStore('utils', {
  state: () => ({
    isLoading: false,
  }),
  persist: true,
  actions: {
    setIsLoading(isLoading) {
      this.isLoading = isLoading
    },
  },
})
